'use strict';

var toastMessageHelper = require('../utils/toastMessageHelper');

$(document).ready(function () {
    var $currencyError = $('.giftvoucher-currency-error');

    if ($currencyError.length > 0) {
        var messageText = $currencyError.text();

        toastMessageHelper.showNotification(messageText);
    }
});
